import React, { Component } from 'react';
import { isEmpty } from '../Common/Common';
import register_icon from '../../Images/Daikin_Images/image/register.png';
import delete_icon from '../../Images/Daikin_Images/image/Delete.png';
import search_icon from '../../Images/Daikin_Images/image/Search.png';
import calendar_icon from '../../Images/Daikin_Images/image/Calendar.png';
import ConfirmMessage from '../Part_Sample/ConfirmMessage';
import Fan_Step from '../Group/Group_Details/Operation/Components/Fan_Step';
import '../Reports/Billing/Bill_Information.css';
import print_icon from '../../Images/Daikin_Images/image/Print.png';
import save_csv_icon from '../../Images/Daikin_Images/image/SaveData.png';
import show_bill_icon from '../../Images/Daikin_Images/image/ShowBill.png';
import show_all_bill_icon from '../../Images/Daikin_Images/image/ShowAll.png';
import weekend_icon from '../../Images/Daikin_Images/image/Weekend.png';
import holiday_calendar_icon from '../../Images/Daikin_Images/image/HolidayCalendar.png';

export default class Bottom_Controls_Bar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			is_show_confirm: false,
			is_show_holiday_settings: false,
		}
	}

	// Toggle show/hide holiday settings
	handleHolidaySettings = (is_show_holiday_settings) => {
		this.setState({ is_show_holiday_settings: is_show_holiday_settings })
	}

	handleRegister = () => {
		window.app.content_area.current.switch_content.current.ref.current.handleRegister();
	}

	handleDelete = () => {
		this.setState({ is_show_confirm: true })
	}

	handleLeftButtonAction = () => {
		window.app.content_area.current.switch_content.current.ref.current.handleLeftButtonAction();
	}

	handleLeftButton2Action = () => {
		window.app.content_area.current.switch_content.current.ref.current.handleLeftButton2Action();
	}

	onConfirm = (is_pressed_ok) => {
		this.setState({ is_show_confirm: false })
		if (is_pressed_ok) {
			window.app.content_area.current.switch_content.current.ref.current.handleDelete();
		} else {
			return;
		}
	}

	render() {
		// styling for bottom menu bar
		let bottomLabelContainer = {
			background: '#00A0E4',
			color: '#FFFFFF',
			width: '100%',
			overflowX: 'auto',
			textAlign: 'center',
		}

		let bottomContainer = {
			position: 'fixed',
			bottom: '0',
			width: '100%',
		}

		let navContainer = {
			width: '100%',
			height: '55px',
			backgroundColor: this.props.colours.midnight_sky,
		}

		let nav_col_left = {
			color: 'white',
			width: '70%',
			display: 'inline-block',
			verticalAlign: 'top'
		}

		let nav_col_right = {
			color: 'white',
			width: '30%',
			display: 'inline-block',
			verticalAlign: 'top'
		}

		let icon_width = 28;
		let icon_style = {
			width: icon_width,
			backgroundColor: 'white',
			borderRadius: icon_width / 2
		}

		let is_show_delete = false;
		let is_show_register = false;
		let register_label = this.props.receiver.getString('save');
		let delete_label = this.props.receiver.getString('delete');

		let is_show_left_button = false;
		let is_show_left_button_2 = false;
		let is_show_right_button = false;
		let left_button_icon = null;
		let left_button_2_icon = null;
		let right_button_icon = null;
		let left_button_2_label = "";

		switch (this.props.tag) {
			case 'Schedule_Office_Summary':
				is_show_register = true;
				is_show_delete = this.props.param.program_id != null ? true : false;
				break;
			case 'Schedule_Step1_Name':
			case 'Schedule_Step2_Target':
			case 'Schedule_Step4_Execute_Days':
			case 'Interlock_Step1_Name':
				is_show_register = true;
				is_show_delete = false;
				register_label = this.props.receiver.getString('next');
				break;
			case 'Add_Edit_Pattern':
				is_show_register = true;
				is_show_delete = this.props.param.pattern_id != '' ? true : false;
				break;
			case 'Add_Edit_Calendar':
				is_show_register = true;
				is_show_delete = this.props.param.calendar_id != null && this.props.param.calendar_id != '' ? true : false;
				break;
			case 'Add_Edit_Action':
				is_show_register = true;
				is_show_delete = this.props.param.time != null ? true : false;
				register_label = this.props.receiver.getString('confirm');
				break;
			case 'Interlock_Summary':
				is_show_register = true;
				is_show_delete = this.props.param.program_id != null ? true : false;
				break;
			case 'Add_Edit_Input_Condition':
				is_show_register = false;
				is_show_delete = false;
				if (this.props.param.condition_index != null) {
					if (!isEmpty(this.props.param.program.condition[this.props.param.condition_index])) is_show_delete = true;
				}
				break;
			case 'Add_Edit_Condition_Detail':
				is_show_register = true;
				is_show_delete = false;
				register_label = this.props.receiver.getString('confirm');
				break;
			case 'Add_Edit_Output_Action':
				is_show_register = true;
				is_show_delete = this.props.param.action_index != null ? true : false;
				break;
			case 'Edit_Interlock_Input':
			case 'Edit_Point_Settings':
			case 'Optional_Group_Display':
			case 'Language':
			case 'Password':
			case 'Report_Settings':
				is_show_register = true;
				is_show_delete = false;
				break;
			case 'Group_Edit':
			case 'History_Change_Filter':
			case 'Trend_Data_Select_Points':
				is_show_register = true;
				is_show_delete = false;
				register_label = this.props.receiver.getString('confirm');
				break;
			case 'Group_Details':
				is_show_register = false;
				// Only admin can delete group
				if (this.props.param.group_id != null) {
					if (this.props.receiver.active_controller.user_class == 'Admin') {
						is_show_delete = true;
					}
				}
				break;
			case 'Add_Edit_Scene':
				is_show_register = true;
				is_show_delete = this.props.param.scene_id != null ? true : false;
				break;
			case 'Add_Edit_Scene_Command':
				is_show_register = true;
				is_show_delete = this.props.param.point_id != null ? true : false;
				break;
			case 'Add_Edit_IAQ':
				is_show_register = true;
				is_show_delete = this.props.param.room_id != null ? true : false;
				break;
			case 'Add_Edit_IAQ_Devices':
				is_show_register = true;
				is_show_delete = this.props.param.selected_iaq_settings_index != null ? true : false;
				break;
			case 'MSM_Add_Edit_Account':
			case 'Add_Edit_Account':
				is_show_register = true;
				is_show_delete = this.props.param.username != null ? true : false;
				break;
			case 'Schedule_Step3_Pattern':
				is_show_register = true;
				is_show_delete = this.props.param.from == 'Schedule_Office_Summary' && this.props.param.pattern_id != '' ? true : false;
				register_label = this.props.receiver.getString('next');
				break;
			case 'Add_Edit_Changeover':
				is_show_register = true;
				is_show_delete = this.props.param.grp_id != null ? true : false;
				break;
			case 'Edit_Layout':
				is_show_register = true;
				is_show_delete = this.props.param.layout_id != null ? true : false;
				break;
			case 'DLinkAddEditCamera':
				is_show_register = true;
				break;
			case 'DLinkNVRDetailsView':
				is_show_register = true;
				is_show_delete = true;
				break;
			case 'DLinkCameraDetailsView':
				is_show_register = true;
				is_show_delete = true;
				break;
			case 'UniviewAddCamera':
				is_show_register = true;
				break;
			case 'UniviewLogin':
				is_show_register = true;
				is_show_left_button = true;
				left_button_icon = search_icon;
				delete_label = this.props.receiver.getString('check');
				break;
			case 'UniviewCameraDetails':
				is_show_register = true;
				break;
			case 'Add_Edit_Schedule_Home':
				is_show_register = true;
				is_show_delete = this.props.param.program_id == null ? false : true;
				break;
			case 'Add_Edit_Tenant':
				is_show_register = true;
				is_show_delete = this.props.param.from == 'add_tenant' ? false : true;
				break;
			case 'Owner_Settings':
				is_show_register = true;
				break;
			case 'Unit_Price_Settings':
				if (this.state.is_show_holiday_settings) {
					is_show_left_button = true;
					is_show_left_button_2 = true;
				} else {
					is_show_left_button = false;
					is_show_left_button_2 = false;
				}
				is_show_register = true;
				left_button_icon = holiday_calendar_icon;
				left_button_2_icon = weekend_icon;
				delete_label = this.props.receiver.getString('calendar');
				left_button_2_label = this.props.receiver.getString("dow");
				break;
			case 'Bill_Settings':
				is_show_left_button = true;
				is_show_left_button_2 = true;
				left_button_icon = show_bill_icon;
				left_button_2_icon = show_all_bill_icon;
				delete_label = this.props.receiver.getString('show');
				left_button_2_label = this.props.receiver.getString("show_all");
				break;
			case 'PPD_Data_Analysis':
				is_show_left_button = true;
				left_button_icon = show_bill_icon;
				delete_label = this.props.receiver.getString('show');
				break;
			case 'Bill_Information':
				// Only show functions if its a PC version
				if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
					is_show_register = true;
					is_show_left_button = true;
					is_show_right_button = true;
					left_button_icon = save_csv_icon;
					right_button_icon = print_icon;
					delete_label = this.props.receiver.getString('save');
					register_label = this.props.receiver.getString('print');
				}
				break;
			case 'Holiday_Calendar_Settings':
			case 'Holiday_DOW_Settings':
				is_show_register = true;
				break;
			case 'Trend_Data':
			case 'Energy_Water_Management':
			case 'Operation_Info':
			case 'Error_Info_Report':
			case 'Export_PPD':
				if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
					is_show_left_button = true;
					left_button_icon = save_csv_icon;
					delete_label = this.props.receiver.getString('save');
				}
				break;
			case 'Add_Edit_Location':
				is_show_register = true;
				is_show_delete = this.props.param.index != null ? true : false;
				break;
			case 'Edit_Guest_Room':
			case 'Control_Param':
				is_show_register = true;
				break;
			case 'Add_Edit_Site':
				is_show_register = true;
				is_show_delete = this.props.param.site_id != null ? true : false;
				break;
			case 'Add_Edit_Region':
				is_show_register = true;
				is_show_delete = this.props.param.selected_region != null ? true : false;
				break;
			default:
		}

		if (this.props.tag == 'Schedule_Step2_Target' && this.props.param.from == 'Schedule_Office_Summary') {
			register_label = this.props.receiver.getString('confirm');
		}

		return (
			<div className="no-print" style={bottomContainer} id='bottom_controls_bar'>
				<ConfirmMessage
					is_show={this.state.is_show_confirm}
					message={this.props.receiver.getString('conf_del')}
					width={this.props.width}
					height={this.props.height}
					receiver={this.props.receiver}
					handleClick={this.onConfirm}
					style={{ top: -(this.props.height - 55) }}
				/>
				<div style={navContainer}>
					<div style={nav_col_left}>
						<div onClick={is_show_left_button ? this.handleLeftButtonAction : this.handleDelete}
							style={{ cursor: 'pointer', display: is_show_delete || is_show_left_button ? 'inline-block' : 'none', textAlign: 'center', marginLeft: 10 }}>
							<div style={{ paddingTop: 5, height: 30 }}>
								<img src={is_show_left_button ? left_button_icon : delete_icon} alt='delete_icon' style={icon_style} />
							</div>
							<div style={{ marginTop: -5 }}>
								<span>{this.props.receiver.getString(delete_label)}</span>
							</div>
						</div>
						<div onClick={this.handleLeftButton2Action}
							style={{ cursor: 'pointer', display: is_show_left_button_2 ? 'inline-block' : 'none', marginLeft: 20, textAlign: 'center' }}>
							<div style={{ paddingTop: 5, height: 30 }}>
								<img src={left_button_2_icon} alt='delete_icon' style={icon_style} />
							</div>
							<div style={{ marginTop: -5 }}>
								<span>{left_button_2_label}</span>
							</div>
						</div>
					</div>
					<div style={nav_col_right} onClick={this.handleRegister}>
						<div style={{ cursor: 'pointer', display: is_show_register ? 'block' : 'none', textAlign: 'center', float: 'right', marginRight: 20 }}>
							<div style={{ paddingTop: 5, height: 30 }}>
								<img src={is_show_right_button ? right_button_icon : register_icon} alt='register_icon' style={icon_style} />
							</div>
							<div style={{ marginTop: -5 }}>
								<span>{this.props.receiver.getString(register_label)}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)

	}
}